import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { KYMW1202Model } from '../kymw1202.model';
import { Injectable } from '@angular/core';
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { MediumInfo } from '../vo/medium-info.model';

// レスポンス構造
export type GetPublishMediumInfoResponse = {
  PCode: string;
  GuideGoodsName: string;
  GuideStandardName: string;
  PublishMediumList: {
    IsSelected: string;
    MediumType: string;
    MediumName: string;
  }[];
};

/**
 * 掲載媒体情報取得サービス
 * @export GetPublishMediumInfo
 * @class GetPublishMediumInfo
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetPublishMediumInfo extends PlessJsonResponderSub<GetPublishMediumInfoResponse> {
  private model: KYMW1202Model;
  private calbak: () => void;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetPublishMediumInfo
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        PCode: this.model.pCode,
      },
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetPublishMediumInfo
   */
  execute(model: KYMW1202Model, f: () => void = null): void {
    this.model = model;
    this.calbak = f;
    this.send('getPublishMediumInfo', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetPublishMediumInfo
   */
  success(data: GetPublishMediumInfoResponse) {
    this.model.pCode = data.PCode;
    this.model.guideGoodsName = data.GuideGoodsName;
    this.model.guideStandardName = data.GuideStandardName;
    this.model.list = data.PublishMediumList.map(_ => new MediumInfo(_));
    this.model.listOrigin = data.PublishMediumList.map(_ => new MediumInfo(_));
    if (this.calbak) this.calbak();
  }

}
